module.exports = __webpack_public_path__ + "static/media/horizontal_com_fotos_conteudos.6cbe0672.jpg";